









import { Component, Vue } from 'vue-property-decorator'
import Login from '@/components/authentication/Login.vue'
import Navbar from '@/components/navbar/Navbar.vue'
import Inicial from '@/components/modulos/Inicial.vue'

@Component({
  components: {
  Navbar,
  Login,
  Inicial
  },
  })
export default class Home extends Vue {
}
